import { render, staticRenderFns } from "./Noodles.vue?vue&type=template&id=48b57e6e&"
import script from "./Noodles.vue?vue&type=script&lang=js&"
export * from "./Noodles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports